const APP_ENDPOINTS = {
  LOGIN: "/login",
  My_PORTFOLIO: "/",
  ADMIN: "/admin",
  Blogs: "/blogs",
};

export default APP_ENDPOINTS;
